import request from 'utils/axios';
import { BASE_URL, TOKEN_KEY, USER_KEY } from 'configs';
import { getFromLocal, removeFromLocal, saveToLocal } from 'utils/cache';
import { UserResponse } from './types';

export const AUTH_URL = `${BASE_URL}/api/auth`;

/**
 * Called once right after MSAL hands back a validated Microsoft ID token.
 * The backend JIT-activates the invited user and writes a LOGIN audit row
 * (see the UAM CMS Backend Postman collection). Returns 403 if there is no
 * invited `users` row for this email, or the account is deactivated.
 */
export const login = (idToken: string): Promise<UserResponse> => {
  return request(`${AUTH_URL}/login`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${idToken}` },
  });
};

export const logout = (): Promise<void> => {
  return request(`${AUTH_URL}/logout`, { method: 'POST', includeAuth: true });
};

export const saveTokenToLocal = (idToken: string) => saveToLocal(TOKEN_KEY, idToken, false);
export const getTokenFromLocal = () => getFromLocal(TOKEN_KEY, false) as string | null;
export const removeTokenFromLocal = () => removeFromLocal(TOKEN_KEY);

export const saveUserToLocal = (user: UserResponse) => saveToLocal(USER_KEY, user);
export const getUserFromLocal = () => getFromLocal(USER_KEY) as UserResponse | null;
export const removeUserFromLocal = () => removeFromLocal(USER_KEY);
